import { PropsWithChildren } from 'react';

import { GlobalClasses } from 'helpers';

import { cx } from '../theme';

import { LinkStyled } from './Link.styles';
import { LinkProps } from './types';

/**
 * Link component.
 */
export const Link = ({
  href,
  target,
  disabled,
  children,
  className,
  mode = 'default',
  onClick,
}: LinkProps & PropsWithChildren) => (
  <LinkStyled
    className={cx(GlobalClasses.hovered, className)}
    disabled={disabled}
    href={href}
    mode={mode}
    target={target}
    onClick={!disabled ? onClick : undefined}
  >
    {children}
  </LinkStyled>
);
